import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const Invite = ({
  eyebrow = "A conversation, not a pitch",
  title = "If your brand is heading to Türkiye, we should talk.",
  text = "Send us the brief, the category and the timing you have in mind. We respond within one business day with an honest read — even if our read is that this isn't the right moment."
}) => (
  <section className="invite">
    <div className="shell">
      <div className="layout">
        <div>
          <span className="eyebrow eyebrow--light">{eyebrow}</span>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="actions">
          <Link to="/contact" className="btn btn--primary">
            Start the conversation <FiArrowRight />
          </Link>
          <Link to="/services" className="btn btn--line-light">All services</Link>
        </div>
      </div>
    </div>
  </section>
);

export default Invite;
